import { render, staticRenderFns } from "./TrendPeriod.vue?vue&type=template&id=13421e34&scoped=true"
import script from "./TrendPeriod.vue?vue&type=script&lang=ts"
export * from "./TrendPeriod.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13421e34",
  null
  
)

export default component.exports